import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import ViewPurchase from "../../components/purchase/ViewPurchase";

const ViewPurchasePage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="VIEW PURCHASE" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <ViewPurchase />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ViewPurchasePage;
